'use client';

import { GavResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  result: GavResult;
  translations: ToolsTranslations['gav'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  const currency = (v: number) => v.toLocaleString('sv-SE') + ' kr';
  return (
    <div className="space-y-6">
      <div className="rounded-lg bg-gray-50 p-4 border border-gray-200">
        <div className="text-sm text-gray-600 mb-1">{translations.totalCost}</div>
        <div className="text-2xl font-semibold text-blue-900">{result.totalCost !== null ? currency(result.totalCost) : '—'}</div>
      </div>
      <div className="rounded-lg bg-gray-50 p-4 border border-gray-200">
        <div className="text-sm text-gray-600 mb-1">GAV:</div>
        <div className="text-2xl font-semibold text-blue-900">{result.gav !== null ? currency(result.gav) : '—'}</div>
        <p className="text-xs text-gray-500 mt-1 italic">{translations.gavHint}</p>
      </div>
      {!result.isValid && result.message && (
        <p className="text-sm text-red-600">{result.message}</p>
      )}
    </div>
  );
}


